import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import { companyDataState } from "../types/reduxState";
import { formatDate } from "../../components/common/formatDate";

interface appActions {
  type: string;
  payload: any;
}

function createData(
  company_name: string | null,
  industry: string | null,
  contact_person: string | null,
  email: string | null,
  phone_number: string | null,
  address: string | null,
  city: string | null,
  state: string | null,
  postal_code: string | null,
  country: string | null,
  website: string | null,
  description: string | null,
  logo_image_path: string | null,
  linkedin_profile: string | null,
  created_at: string,
  updated_at: string,
  no_of_employees: number | null,
  location: string | null,
  founded_in: number | null,
  headquarter: string | null,
  industry_operate_in: string | null,
  twitter_profile: string | null,
  facebook_profile: string | null,
  status: string,
  instagram_profile: string | null,
  companyId?: number,
): CompanyData {
  return {
    company_name,
    industry,
    contact_person,
    email,
    phone_number,
    address,
    city,
    state,
    postal_code,
    country,
    website,
    description,
    logo_image_path,
    linkedin_profile,
    created_at,
    updated_at,
    no_of_employees,
    location,
    founded_in,
    headquarter,
    industry_operate_in,
    twitter_profile,
    facebook_profile,
    status,
    instagram_profile,
    companyId,
  };
}


interface CompanyData {
  company_name: string | null;
  industry: string | null;
  contact_person: string | null;
  email: string | null;
  phone_number: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country: string | null;
  website: string | null;
  description: string | null;
  logo_image_path: string | null;
  linkedin_profile: string | null;
  created_at: string;
  updated_at: string;
  no_of_employees: number | null;
  location: string | null;
  founded_in: number | null;
  headquarter: string | null;
  industry_operate_in: string | null;
  twitter_profile: string | null;
  facebook_profile: string | null;
  instagram_profile: string | null;
  status: string;
  actions?: any;
  companyId?: number;
}

// name
// Number	
// Company Name
// Company Founded in	
// Number of Employees	
// Headquarter	
// Industry company operates in	
// About the Company	
// Company Website	
// Twitter Link	
// Linkedin	
// Instagram

function convertApiToTableData(apiResponse: any) {
  return apiResponse.map((company: any) =>
    createData(
      company.name ?? "-",                 
      "-",                                
      "-",                                
      "-",                                
      "-",                                
      "-",                                
      company.headquarter ?? "Unknown",     
      "Unknown",                            
      "-",                                
      "India",                              
      company.website ?? "-",             
      company.description ?? "No description available", 
      company.logo ?? "",                   
      company.linkedinProfile ?? "",        
      company.createdDate ?? company.createdAt ?? company.created_date ?? "",             
      company.updatedDate ?? company.updatedAt ?? company.updated_date ?? "",             
      company.noOfEmployees ?? 0,           
      company.headquarter ?? "-",            
      company.foundedIn ?? 0,               
      company.headquarter ?? "-",            
      company.industryOperateIn?.join(", ") ?? "-", 
      company.twitterProfile?.length > 0 ? company.twitterProfile : "-  ",         
      "-",                                   
      company.status,                       
      "-",                                   
      company.companyId ?? 0,                      
    )
  );
}


export default function companyReducer(currentState: companyDataState, action: appActions): any {
  const state = currentState || initialState.companyList;
  switch (action.type) {
    case types.SET_COMPANY_LIST:
      return {
        ...state,
        list: action.payload.records?.length ? convertApiToTableData(action.payload.records) : [],
        page: action.payload.page,
        rowsPerPage: action.payload.fetchSize,
        totalCount: action.payload.totalRecords,
      };
    case types.SET_COMPANY_LIST_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case types.SET_COMPANY_LIST_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.payload,
        page: 1,
      };
    case types.SET_COMPANY_LIST_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
